export const getNameFilter = ({ filters: { nameFilter } = {} }) => nameFilter;
export const getTagFilter = ({ filters: { tagFilter } = {} }) => tagFilter;
